<mat-table
  [dataSource]="sortedProducts"
  class="product-table"
  [ngClass]="{ 'with-divider': showDivider }">
  <ng-container matColumnDef="product-number">
    <mat-header-cell *matHeaderCellDef style="justify-content: center">
      Artikel-Nr.
    </mat-header-cell>
    <mat-cell *matCellDef="let product" class="product-nr-column">
      {{ product.id }}
    </mat-cell>
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="product">
    <mat-header-cell *matHeaderCellDef class="product-column">
      Artikel
    </mat-header-cell>
    <mat-cell *matCellDef="let product" class="product-column">
      <img [src]="product.imageUrl" class="product-img" />
      <div class="name-container">
        <p class="brand">{{ product.brand }}</p>
        <p class="name">
          <span class="name-text">{{ product.name }}</span>
          <span *ngIf="hasDeposit(product)" class="deposit-label">
            ({{ getDepositLabel(product) }})
          </span>
        </p>
      </div>
    </mat-cell>
    <mat-footer-cell *matFooterCellDef class="product-column"></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="price">
    <mat-header-cell *matHeaderCellDef>Einzelpreis</mat-header-cell>
    <mat-cell *matCellDef="let product">
      € {{ product.price | number: '1.2-2' }}
    </mat-cell>
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="sum">
    <mat-header-cell *matHeaderCellDef>Gesamt</mat-header-cell>
    <mat-cell *matCellDef="let product">
      <span class="highlight">€ {{ product.total | number: '1.2-2' }}</span>
    </mat-cell>
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <mat-header-cell
      *matHeaderCellDef
      class="quantity-column quantity-column-header">
      Anzahl
    </mat-header-cell>
    <mat-cell *matCellDef="let product" class="quantity-column">
      <app-product-counter
        style="width: 160px"
        [checkResident]="false"
        [counter]="getProductCount(product)"
        [canIncrease]="zeroPriceState(product).canIncrease"
        [maxQuantity]="zeroPriceState(product).maxQuantity"
        (click)="counterClick($event)"
        (counterChange)="
          onCounterChange($event, product)
        "></app-product-counter>
    </mat-cell>
    <mat-footer-cell
      *matFooterCellDef
      class="quantity-column"></mat-footer-cell>
  </ng-container>

  <ng-container
    matColumnDef="delete"
    *ngIf="permissionsService.canAddProductsToCart()">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let product" class="delete-column">
      <mat-icon
        svgIcon="trash-icon"
        class="trash-icon"
        (click)="showDeleteModal(product.id)"></mat-icon>
    </mat-cell>
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <mat-header-row
    *matHeaderRowDef="displayedColumns"
    [style.display]="hideHeaders ? 'none' : 'flex'"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

  <ng-container matColumnDef="deposit-product-number">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="deposit-product">
    <mat-footer-cell *matFooterCellDef class="product-column">
      <div class="summary-row">
        <img
          [src]="'/assets/icons/recycling-flasche.svg'"
          class="packaging-img" />
        <p class="packaging-name" lang="de">Pfand</p>
      </div>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="deposit-price">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="deposit-sum">
    <mat-footer-cell *matFooterCellDef>
      <span class="highlight">€ {{ residentDeposit | number: '1.2-2' }}</span>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="deposit-quantity">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container
    matColumnDef="deposit-delete"
    *ngIf="permissionsService.canAddProductsToCart()">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="packaging-product-number">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="packaging-product">
    <mat-footer-cell *matFooterCellDef class="product-column">
      <div class="summary-row">
        <img [src]="'/assets/icons/packaging-icon.svg'" class="packaging-img" />
        <p class="packaging-name" lang="de">Enthaltene Verpackungspauschale</p>
      </div>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="packaging-price">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="packaging-sum">
    <mat-footer-cell *matFooterCellDef>
      <span class="highlight">€ {{ packagingPrice | number: '1.2-2' }}</span>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="packaging-quantity">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container
    matColumnDef="packaging-delete"
    *ngIf="permissionsService.canAddProductsToCart()">
    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
  </ng-container>

  <ng-container *ngIf="residentDeposit > 0">
    <mat-footer-row *matFooterRowDef="depositFooterColumns"></mat-footer-row>
  </ng-container>
  <ng-container *ngIf="packagingPrice > 0">
    <mat-footer-row *matFooterRowDef="packagingFooterColumns"></mat-footer-row>
  </ng-container>
</mat-table>
